import * as React from 'react';

const SvgUniqueErgo2 = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 148 151"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M73.838 150c40.228 0 72.838-32.583 72.838-72.777 0-40.193-32.61-72.777-72.838-72.777C33.611 4.446 1 37.03 1 77.223 1 117.417 33.61 150 73.838 150Z"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.84 120.082c23.691 0 42.896-19.189 42.896-42.86 0-23.67-19.205-42.86-42.895-42.86-23.69 0-42.896 19.19-42.896 42.86 0 23.671 19.205 42.86 42.896 42.86Z"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.121 38.242a39.52 39.52 0 0 1 29.276 7.466 39.435 39.435 0 0 1 15.421 25.955 39.407 39.407 0 0 1-7.475 29.243 39.508 39.508 0 0 1-41.363 14.583 39.48 39.48 0 0 1-13.894-6.641A39.431 39.431 0 0 1 39.796 97.4a39.384 39.384 0 0 1-5.117-14.511 39.44 39.44 0 0 1 7.478-29.231 39.524 39.524 0 0 1 25.964-15.416Z"
      fill="url(#unique-ergo-2_svg__a)"
    />
    <path
      d="M73.84 124.474c2.457 0 4.45-1.99 4.45-4.445a4.448 4.448 0 0 0-4.45-4.446 4.448 4.448 0 0 0-4.45 4.446 4.447 4.447 0 0 0 4.45 4.445Z"
      fill="#FF5E18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.694 28.178a1.329 1.329 0 0 1-.789-1.792 1.325 1.325 0 0 1 1.258-.902c.185 0 .367.039.536.113a55.298 55.298 0 0 1 25.78 20.31 55.173 55.173 0 0 1 9.616 31.369 55.084 55.084 0 0 1-9.687 31.19 55.236 55.236 0 0 1-25.78 20.327 1.344 1.344 0 0 1-1.795-.788 1.384 1.384 0 0 1 .332-1.504c.132-.125.288-.224.458-.289a52.497 52.497 0 0 0 24.488-19.324 51.946 51.946 0 0 0 9.275-29.612 52.05 52.05 0 0 0-9.203-29.702 52.773 52.773 0 0 0-24.489-19.396ZM55.02 126.212a1.384 1.384 0 0 1 .768.732 1.38 1.38 0 0 1 .022 1.061 1.366 1.366 0 0 1-1.794.788 55.23 55.23 0 0 1-25.78-20.327 54.963 54.963 0 0 1-9.617-31.19 55.052 55.052 0 0 1 9.706-31.244 55.302 55.302 0 0 1 25.78-20.31 1.346 1.346 0 0 1 1.794.79 1.325 1.325 0 0 1-.789 1.792A52.774 52.774 0 0 0 30.55 47.52a51.953 51.953 0 0 0-9.204 29.756 51.737 51.737 0 0 0 9.204 29.666 52.505 52.505 0 0 0 24.488 19.27h-.018Z"
      fill="url(#unique-ergo-2_svg__b)"
    />
    <path
      d="M95.8 15.523a7.764 7.764 0 0 0 7.768-7.761A7.764 7.764 0 0 0 95.8 0c-4.29 0-7.768 3.475-7.768 7.762 0 4.286 3.478 7.761 7.768 7.761ZM20.056 137.094c5.985 0 10.836-4.848 10.836-10.827 0-5.98-4.851-10.827-10.836-10.827-5.984 0-10.836 4.847-10.836 10.827 0 5.979 4.852 10.827 10.836 10.827Z"
      fill="#FF5E18"
    />
    <defs>
      <radialGradient
        id="unique-ergo-2_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 39.4357 -39.469 0 73.75 77.277)"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={0.557} stopColor="#FF5E18" stopOpacity={0.589} />
        <stop offset={1} stopColor="#FF5E18" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="unique-ergo-2_svg__b"
        x1={58.501}
        y1={80.862}
        x2={57.605}
        y2={25.293}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={0.34} stopColor="#FF5E18" stopOpacity={0.46} />
        <stop offset={1} stopColor="#FF5E18" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgUniqueErgo2;
